export enum NCFileDetailsScreen {
  PART = 'NCFileDetailsPart',
  JOBS = 'NCFileDetailsJobs',
  BATCH = 'NCFileDetailsBatch',
  NC_FILE = 'NCFileDetailsNCFile',
  TOOLS = 'NCFileDetailsTools',
}

export enum NCFileDetailsScreenLink {
  PART = 'part',
  BATCH = 'batch',
  NC_FILE = 'nc-file',
  JOBS = 'jobs',
  TOOLS = 'tools',
}

export enum NCFileLevelSubScreen {
  GENERAL = 'General',
  // TIMELINE = 'Timeline',
  TIMES = 'Times',
  // EVENTS = 'Events',
  PERFORMANCE = 'Performance',
  VERSIONS = 'Versions',
  LINKS = 'Links',
  DOCUMENTS = 'Documents',
  TRACEABILITY = 'Traceability'
}

export enum NCFileLevelSubScreenLink {
  GENERAL = 'general',
  // TIMELINE = 'timeline',
  TIMES = 'times',
  // EVENTS = 'events',
  PERFORMANCE = 'performance',
  VERSIONS = 'versions',
  LINKS = 'links',
  DOCUMENTS = 'documents',
  TRACEABILITY = 'traceability'
}
